import { useMemo } from 'react';
import { usePermissions } from './usePermissions';

export interface FabPermissions {
  canCreateSite: boolean;
  canCreateInspection: boolean;
  canCreateDocument: boolean;
  reasons: {
    site?: string;
    inspection?: string;
    document?: string;
  };
}

const SITE_REASON = '현장 관리 권한이 없습니다';
const INSPECTION_REASON = '점검 관리 권한이 없습니다';
const DOCUMENT_REASON = '문서 생성 권한이 없습니다';

/**
 * FAB(빠른 생성) 버튼 세 개의 권한 — 전부 `can(key)`(company-rbac P4). 생성 버튼이라 각 도메인의 **생성** 키를 본다:
 * 현장 `site.manage`(현장 생성·삭제 키) · 점검 `inspection.create` · 문서 `report.create`. 옛 판정
 * (`isOwner || (SAFETY_MANAGER && canManage*)`)은 폐기 — owner는 서버가 전체 키를 주므로 별도 분기가 없다.
 */
export function useFabPermissions(): FabPermissions {
  const { can } = usePermissions();

  return useMemo(() => {
    const canCreateSite = can('site.manage');
    const canCreateInspection = can('inspection.create');
    const canCreateDocument = can('report.create');

    return {
      canCreateSite,
      canCreateInspection,
      canCreateDocument,
      reasons: {
        site: canCreateSite ? undefined : SITE_REASON,
        inspection: canCreateInspection ? undefined : INSPECTION_REASON,
        document: canCreateDocument ? undefined : DOCUMENT_REASON,
      },
    };
  }, [can]);
}
